import { render, staticRenderFns } from "./InspectionItemEdit.vue?vue&type=template&id=c2dbe59a&"
import script from "./InspectionItemEdit.vue?vue&type=script&lang=js&"
export * from "./InspectionItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports